/**
 * TAJ szám ellenőrzése - ugyanaz a szabály, mint a backend Taj.Validate-je:
 * 9 számjegy (szóköz és kötőjel megengedett), a 9. az ellenőrző számjegy
 * (páratlan helyiértékek ×3, párosak ×7, összegük 10-es maradéka).
 */
export const normalizeTaj = (value: string): string => value.replace(/[\s-]/g, '');

/** Hibás TAJ-nál a hibaüzenet, üres vagy helyes értéknél null. */
export const validateTaj = (value: string): string | null => {
  const taj = normalizeTaj(value);
  if (!taj) return null;
  if (!/^\d{9}$/.test(taj)) return 'A TAJ szám 9 számjegyből áll (pl. 123 456 789).';

  const digits = taj.split('').map(Number);
  const sum = digits.slice(0, 8).reduce((acc, d, i) => acc + d * (i % 2 === 0 ? 3 : 7), 0);
  return sum % 10 === digits[8] ? null : 'Ez a TAJ szám nem érvényes (az ellenőrző számjegy nem stimmel).';
};
